












































































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Asset } from '@/js/Asset'
import TooltipMeta from '@/components/misc/TooltipMeta.vue'
import { Transaction } from '@/js/Transaction'
import { getAssetType } from '@/services/assets'
import { backgroundColor } from '@/helper'
import { getTxChainType } from '@/known_blockchains'

@Component({
    components: {
        TooltipMeta,
    },
    filters: {
        getAssetType,
    },
})
export default class Metadata extends Vue {
    @Prop() asset!: Asset
    @Prop() genesisTx!: Transaction

    get minimalTransferrableUnit() {
        const power = -1 * this.asset.denomination
        return Math.pow(10, power).toFixed(this.asset.denomination)
    }

    get isNFT() {
        return this.asset.nft === 1
    }

    get date(): Date {
        return new Date(this.genesisTx.timestamp)
    }

    get background(): string {
        const chain = getTxChainType(this.asset.chainID)
        return chain ? backgroundColor(chain.code) : '#fff'
    }
}
